import { useQuery } from "react-query";
import {
  type BillingProduct,
  billingCyclesApi,
} from "@/react/api/billingCyclesApi";

interface UseBillingCyclesProps {
  enabled?: boolean;
  limit?: number;
  products?: BillingProduct[];
}

export const useBillingCycles = ({
  enabled = false, // Changed default to false for lazy loading
  limit = 12,
  products = ["ai_actions"], // Default to ai_actions for AI Actions billing
}: UseBillingCyclesProps = {}) => {
  const { data, isLoading, error, refetch } = useQuery(
    ["billing-cycles", limit, products],
    () => billingCyclesApi.fetchBillingCycles({ limit, products }),
    {
      enabled,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    },
  );

  return {
    billingCycles: data?.billing_cycles || [],
    isLoading,
    error,
    refetch,
    hasData: !!data,
  };
};
